export default __webpack_public_path__ + "static/WebUI-MenuVideoBar_Microphone-70d2ecd7a0cdbad4910d432bc596f42d.png";